export function isActivateKey(event) {
    return event.key === 'Enter' || event.key === ' ' || event.keyCode === 13 || event.keyCode === 32;
}

export function activateClick(element) {
    element.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
    }));
}

export function onActivateKey(element, handler) {
    element.addEventListener('keydown', (event) => {
        if (!isActivateKey(event)) {
            return;
        }
        event.preventDefault();
        handler(event);
    });
}
